import flatpickr from 'flatpickr' // flatpickr
import 'flatpickr/dist/l10n/ja' // flatpickr日本語化
/*
<script src="<?php echo T_URL; ?>/js/form.min.js?v=<?php echo filemtime(T_PATH . '/js/form.min.js'); ?>"></script>
*/

/*
##     ##    ###    ##       #### ########     ###    ######## ########
##     ##  ##   ##  ##        ##  ##     ##  ##   ##     ##    ##
##     ## ##     ## ##        ##  ##     ## ##     ##    ##    ######
 ##   ##  ######### ##        ##  ##     ## #########    ##    ##
   ###    ##     ## ######## #### ########  ##     ##    ##    ########
*/
/*
jQuery-Validation-Engine
<script src="//cdnjs.cloudflare.com/ajax/libs/jquery-migrate/3.0.1/jquery-migrate.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/jQuery-Validation-Engine/2.6.4/languages/jquery.validationEngine-ja.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/jQuery-Validation-Engine/2.6.4/jquery.validationEngine.min.js"></script>
*/
if (document.querySelector('[name^="ok"]')) {
  // 規約同意のエラー文を変更する
  document.querySelector('[name^="ok"]').setAttribute('data-errormessage', '同意の上チェックしてください')
}

if (document.getElementsByClassName('mw_wp_form')[0]) {
  // MW側のSubmit禁止処理を外す
  const observeItem = document.querySelector('input[type="submit"]')
  const observer = new MutationObserver((records) => {
    if (!observeItem.hasAttribute('disabled')) {
      return
    }
    observeItem.removeAttribute('disabled')
  })
  observer.observe(observeItem, {
    // 指定要素の変化を監視
    attributes: true, // 属性の変化を監視
    attributeFilter: ['disabled'], // 監視する属性
  })

  jQuery(function ($) {
    // ひらがな、カタカナの確認をする
    jQuery.validationEngineLanguage.allRules['furigana'] = {
      regex: /^[\u3040-\u309F\u30A0-\u30FF\s]+$/,
      alertText: 'ひらがなまたカタカナでご入力してください',
    }
    $('.mw_wp_form').find('form').validationEngine({
      scrollOffset: 200,
    })
  })
}
/*
条件に応じて以下のclassを各inputに設定する
■必須入力
validate【required】
■指定の書式
validate【custom【email】】
validate【custom【phone】】
validate【custom【url】】
custom【date】
■複合
validate【required,custom【email】】
validate【required,custom【phone】】
■指定IDと入力内容が一致
validate【equals【id】】
■指定IDがチェック済みなら必須入力に変更
validate【condRequired【id】】
■指定範囲の文字数
validate【maxSize【10】】
validate【minSize【10】】
■整数のみ
validate【custom【integer】】
■数字のみ
validate【custom【number】】
■英数字のみ
validate【custom【onlyLetterNumber】】
■英字と空白のみ
validate【custom【onlyLetterSp】】
■数字と空白のみ
validate【custom【onlyNumberSp】】
■指定範囲の数値
validate【min【-5】】
validate【max【30】】
■指定範囲の日付
validate【custom【date】,past【2010/01/01】】
validate【custom【date】,future【NOW】】
■チェックボックスのチェック数
validate【minCheckbox【2】】
validate【maxCheckbox【2】】
*/

// ショートコード誤認回避の【】を[]に戻す
const validateItems = document.querySelectorAll('[class*="【"]')
if (validateItems[0]) {
  for (let index = 0; index < validateItems.length; index++) {
    const validateItem = validateItems[index]
    const validateClass = validateItem.getAttribute('class').replace(/【/g, '[').replace(/】/g, ']')
    validateItem.setAttribute('class', validateClass)
  }
}

/*
 ######  ######## ##       ########  ######  ########
##       ##       ##       ##       ##          ##
 ######  ######   ##       ######   ##          ##
      ## ##       ##       ##       ##          ##
 ######  ######## ######## ########  ######     ##
*/
// // 空のセレクトボックスに文を入れる
// const blankSelect = document.querySelectorAll('.mw_wp_form select option[value=""]')
// if (blankSelect[0]) {
//   for (let index = 0; index < blankSelect.length; index++) {
//     blankSelect[index].innerText = '選択してください'
//   }
// }

/*
######## #### ########
    ##    ##  ##     ##
   ##     ##  ########
  ##      ##  ##
######## #### ##
*/
/*
郵便番号から住所を検索する
以下の外部JSが必要
<script src="//ajaxzip3.github.io/ajaxzip3.js" charset="UTF-8"></script>
*/
// /* global AjaxZip3 */
if (document.getElementById('js-zip')) {
  document.getElementById('js-zip').addEventListener(
    'keyup',
    function () {
      // 各入出力先をnameから指定
      // 郵便番号上3桁もしくは7桁, 郵便番号下4桁（不要なら空欄）, 都道府県の出力先, 市区町村～町域の出力先
      AjaxZip3.zip2addr('zip', '', 'address', 'address')
    },
    false
  )
}

/*
 ######   #######  ##    ## ##     ## ######## ########  ########
##       ##     ## ####  ## ##     ## ##       ##     ##    ##
##       ##     ## ## ## ## ##     ## ######   ########     ##
##       ##     ## ##  ####  ##   ##  ##       ##   ##      ##
 ######   #######  ##    ##    ###    ######## ##     ##    ##
*/
// 特定のテキストフォームを適した形式に変える

// // 電話番号→tel
// let convertInput = document.querySelector('[type="text"][name="tel"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'tel')
// }

// // 郵便番号→number
// // スピンボタンが付いてしまうので以下のようなCSSで消す必要がある
// /*
// input[type="number"]::-webkit-outer-spin-button,
// input[type="number"]::-webkit-inner-spin-button {
//   -webkit-appearance: none;
//   margin: 0;
// }
// input[type="number"] {
//   -moz-appearance: textfield;
// }
// */
// convertInput = document.querySelector('[type="text"][name="zip1"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'number')
// }
// convertInput = document.querySelector('[type="text"][name="zip2"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'number')
// }
// // メール→email
// convertInput = document.querySelector('[type="text"][name="mail"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'email')
// }

/*
########          ########  ####  ######  ##    ## ######## ########
##     ##         ##     ##  ##  ##    ## ##   ##  ##       ##     ##
##     ##         ##     ##  ##  ##       ##  ##   ##       ##     ##
##     ## ####### ########   ##  ##       #####    ######   ########
##     ##         ##         ##  ##       ##  ##   ##       ##   ##
##     ##         ##         ##  ##    ## ##   ##  ##       ##    ##
########          ##        ####  ######  ##    ## ######## ##     ##
*/
/*
flatpickrによるデートピッカー
本コード冒頭のインポートと_js.scssのCSSインポートを有効化して使用

例：
<input type="text" name="date1" class="js-date">
<input type="text" name="date2" class="js-date">
*/

// // ブラウザバック時に入力値を戻すためにpageshowで動作させる
// window.addEventListener('pageshow', function () {
//   const datepicker = flatpickr('.js-date', {
//     // 指定クラスにデートピッカーを付ける
//     // minDate: new Date().fp_incr(1), // 最短設定日 n日後から
//     // maxDate: new Date().fp_incr(30), // 最長設定日 n日後まで
//     // mode: 'range', // 範囲で指定させる
//     locale: 'ja',
//     altFormat: 'Y/m/d',
//     dateFormat: 'Y/m/d',
//     disableMobile: true, // SP時にブラウザ標準の日付UIに切り替えない
//     // altFormat: 'Y/m/d H:i',
//     // dateFormat: 'Y/m/d H:i',
//     // enableTime: true, // 時間指定可能にする
//     // time_24hr: false, // 24h/AMPM形式
//     disable: [
//       // 選択禁止する日付　trueを返すと禁止
//       // function (date) {
//       //   // 指定番号の曜日と合致したら禁止　0:日曜～6:土曜
//       //   if (date.getDay() === 0) {
//       //     return true
//       //   }
//       // },
//     ],
//     onChange: function (selectedDates, dateStr, instance) {},
//   })

//   // デフォルトのflatpickrにはクリアボタンが無いのでカレンダー内に増設する
//   const datepickerList = document.querySelectorAll('.flatpickr-calendar')
//   for (let index = 0; index < datepickerList.length; index++) {
//     const element = datepickerList[index]
//     const datepickerBtn = document.createElement('button')
//     datepickerBtn.innerHTML = '×クリア' // 文言
//     datepickerBtn.setAttribute('type', 'button')
//     datepickerBtn.setAttribute('style', 'padding: 5px;color: #F67A79')
//     datepickerBtn.setAttribute('data-datepicker-clear', index)
//     datepickerBtn.addEventListener('click', function (e) {
//       if (Array.isArray(datepicker)) {
//         datepicker[this.dataset.datepickerClear].clear() // クリア処理
//         datepicker[this.dataset.datepickerClear].close() // カレンダーを閉じる
//       } else {
//         datepicker.clear() // クリア処理
//         datepicker.close() // カレンダーを閉じる
//       }
//     })
//     element.appendChild(datepickerBtn)
//   }
// })

//  #####     ###     ####  ##  ##
//  ##  ##   ## ##   ##     ## ##
//  #####   ##   ##  ##     ####
//  ##  ##  #######  ##     ## ##
//  #####   ##   ##   ####  ##  ##
// 戻るボタンが存在する場合、ブラウザバックを戻るボタンクリックに差し替える
const backBtn = document.querySelector('.js-backBtn,[name="submitBack"]')
if (backBtn) {
  history.pushState(null, null, null) // 空の履歴を入れてブラウザバック無効化
  //ブラウザバックボタン押下時
  window.addEventListener('popstate', function (e) {
    history.pushState(null, null, null)
    backBtn.click() // フォーム内の戻るボタンを押す
  })
}

//  #####  ##  ##      #####            ##   ##  ##
//  ##     ##  ##      ##               ##   ##  ##
//  #####  ##  ##      #####  ########  ##   ##  ##
//  ##     ##  ##      ##               ##   ##  ##
//  ##     ##  ######  #####             #####   ##
/*
<div class="customFile flex vcenter">
    <label class="customFile__frame flex vcenter">
        <input id="js-customFile--entry" class="js-customFile customFile__input" data-target="entry" type="file" name="entry_file" />
        <div class="customFile__btn flex vcenter hcenter">ファイル選択</div>
        <div class="js-customFile-out--entry customFile__text" data-def="5MB以内のPDFファイルをアップロードしてください。">
            5MB以内のPDFファイルをアップロードしてください。
        </div>
    </label>
    <button type="button" class="js-customFile-toggle--entry js-customFile-del customFile__del" data-target="entry">×クリア</button>
</div>
<input id="js-customFile-name--entry" type="text" class="js-customFile-trace is-none" name="doc" data-target="entry">
*/
// ファイルアップロードUIのカスタム
const customFileUpload = document.getElementsByClassName('js-customFile')
const customFileNameTrace = document.getElementsByClassName('js-customFile-trace')
const customFileReader = new FileReader()
if (customFileUpload[0]) {
  window.addEventListener('change', function (e) {
    fileUpSet(e.target)
  })
  window.addEventListener('click', function (e) {
    fileUpDel(e.target)
  })
}

function fileUpSet(item) {
  if (!item.classList.contains('js-customFile')) {
    return
  }

  item.classList.remove('active')

  const file = item.files[0] // ファイルを取得
  const target = item.dataset.target // 各種反映先のスラッグ
  const fileType = item.dataset.fileType // 許可するファイルタイプ

  const fileSizeLimit = 5 // サイズ上限（MB）
  const sizeUnit = file.size > 1024 * 1024 ? 'MB' : 'KB' // 単位をMBかKBに分岐
  const fileSizeUnit = sizeUnit === 'MB' ? file.size / (1024 * 1024) : file.size / 1024 // 単位に合わせて補正したファイルサイズ
  const fileSizeView = fileSizeUnit.toFixed(2) + sizeUnit // ファイルサイズ出力テキスト

  // 表示するテキスト
  let fileText = file.name + ' (' + fileSizeView + ')'
  // エラー判定
  let isError = false

  // サイズバリデーション
  if (file.size > fileSizeLimit * (1024 * 1024)) {
    isError = true
    item.value = '' // 入力を削除
    fileText =
      '<span style="color:#ce003b">ファイルサイズは' +
      fileSizeLimit +
      'MB以下にしてください (' +
      fileSizeLimit +
      ')。</span>'
  }
  // 拡張子バリデーション　実際の中身ではなく、ファイル名だけを見る簡単なもの
  if (fileType !== '') {
    const fileTypeList = fileType.split(',') // ,区切りで配列に変換
    if (!checkExt(file.name, fileTypeList)) {
      isError = true
      item.value = '' // 入力を削除
      fileText = '<span style="color:#ce003b">' + fileTypeList + 'ファイルのみがアップロードできます。</span>'
    }
  }

  // ファイル名やエラーを表示させる
  const fileTextTarget = document.getElementsByClassName('js-customFile-out--' + target)
  for (let index = 0; index < fileTextTarget.length; index++) {
    fileTextTarget[index].innerHTML = fileText
    if (isError) {
      fileTextTarget[index].classList.add('active') // エラー時だけ表示する
    } else {
      fileTextTarget[index].classList.remove('active')
    }
  }

  // ファイル名を送信させる
  const fineNameTarget = document.getElementById('js-customFile-name--' + target)
  if (fineNameTarget) {
    if (!isError) {
      fineNameTarget.value = file.name
    } else {
      fineNameTarget.value = ''
    }
  }

  customFileReader.readAsDataURL(file)
  customFileReader.onload = function (event) {
    let isReadFile = false
    // BASE64版のデータをセットする
    const fineBase64Target = document.getElementsByClassName('js-customFile-base64--' + target)

    if (fineBase64Target[0]) {
      if (!isError) {
        for (const iterator of fineBase64Target) {
          iterator.value = customFileReader.result
        }
        isReadFile = true
      } else {
        for (const iterator of fineBase64Target) {
          iterator.value = ''
        }
      }
    }

    // 画像ファイルをプレビューさせる
    const finePreviewTarget = document.getElementsByClassName('js-customFile-preview--' + target)
    if (finePreviewTarget[0]) {
      if (!isError) {
        for (const iterator of finePreviewTarget) {
          iterator.innerHTML = '<img src="' + customFileReader.result + '">'
        }
        isReadFile = true
      } else {
        for (const iterator of finePreviewTarget) {
          iterator.innerHTML = ''
        }
      }
    }
  }

  // 切り替わる要素を反映させる
  const fineDelTarget = document.getElementsByClassName('js-customFile-toggle--' + target)
  if (fineDelTarget[0]) {
    if (!isError) {
      for (const iterator of fineDelTarget) {
        iterator.classList.add('active')
      }
    } else {
      for (const iterator of fineDelTarget) {
        iterator.classList.remove('active')
      }
    }
  }

  // 文字列から拡張子を返す
  function getExt(fileName) {
    const pos = fileName.lastIndexOf('.')
    if (pos === -1) return ''
    return fileName.slice(pos + 1)
  }
  // 拡張子を検証する
  function checkExt(fileName, exts) {
    // 比較のため小文字にする
    const ext = getExt(fileName).toLowerCase()
    // 許可する拡張子の一覧extsから対象の拡張子があるか確認する
    if (exts.indexOf(ext) === -1) {
      return false
    }
    return true
  }
}
function fileUpDel(item) {
  if (!item.classList.contains('js-customFile-del')) {
    return
  }

  const target = item.dataset.target // 各種反映先のスラッグ

  // ファイルを消す
  document.getElementById('js-customFile--' + target).value = ''

  // 送信するファイル名を消す
  const fineNameTarget = document.getElementById('js-customFile-name--' + target)
  if (fineNameTarget) {
    fineNameTarget.value = ''
  }

  // BASE64版のデータを消す
  const fineBase64Target = document.getElementsByClassName('js-customFile-base64--' + target)
  if (fineBase64Target[0]) {
    for (const iterator of fineBase64Target) {
      iterator.value = ''
    }
  }

  // 切り替わる要素を消す
  const fineDelTarget = document.getElementsByClassName('js-customFile-toggle--' + target)
  if (fineDelTarget[0]) {
    for (const iterator of fineDelTarget) {
      iterator.classList.remove('active')
    }
  }

  // テキスト表示欄をリセットする
  const fileTextTarget = document.getElementsByClassName('js-customFile-out--' + target)
  for (let index = 0; index < fileTextTarget.length; index++) {
    fileTextTarget[index].innerHTML = fileTextTarget[index].dataset.def
  }
}

//   ####  ##   ##  #####   ####  ##  ##             #####   #####   #####  ##     ##
//  ##     ##   ##  ##     ##     ## ##             ##   ##  ##  ##  ##     ####   ##
//  ##     #######  #####  ##     ####    ########  ##   ##  #####   #####  ##  ## ##
//  ##     ##   ##  ##     ##     ## ##             ##   ##  ##      ##     ##    ###
//   ####  ##   ##  #####   ####  ##  ##             #####   ##      #####  ##     ##

checkOpen()

window.addEventListener('change', function (e) {
  const item = e.target.closest('.js-checkOpen')
  if (!item) {
    return
  }
  checkOpen()
})

function checkOpen() {
  const checkList = document.getElementsByClassName('js-checkOpen')

  if (!document.getElementsByClassName('js-checkOpen')[0]) {
    return
  }

  for (const check of checkList) {
    const target = check.dataset.target

    const targetList = document.getElementsByClassName('js-checkOpen--' + target)

    if (check.checked) {
      for (const item of targetList) {
        item.classList.add('active')
      }
    } else {
      for (const item of targetList) {
        item.classList.remove('active')
      }
    }
  }
}
